import { mapCommonFields } from './property-mapper-utils';

import type { PropertyRegistrationForm } from '../types/property.types';
import type {
  CreatePropertyRequest,
  CreatePropertyFieldStaff,
  CreatePropertyContractFactory,
} from '../services/properties.service';

/**
 * Transform PropertyRegistrationForm to CreatePropertyRequest (API format)
 * Maps frontend form field names to backend API field names (camelCase)
 */
export const mapFormToCreatePropertyRequest = (
  data: PropertyRegistrationForm,
  canManagePrice: boolean
): CreatePropertyRequest => {
  // Transform fieldStaffs with displayOrder (based on array index)
  const fieldStaffs: CreatePropertyFieldStaff[] = data.field_staffs.map((staff, index) => ({
    displayOrder: index + 1, // 1-based index
    name: staff.name,
    phoneNumber: staff.tel, // tel -> phoneNumber
    mailAddress: staff.email, // email -> mailAddress
  }));

  // Transform contractFactories with displayOrder (based on array index)
  const contractFactories: CreatePropertyContractFactory[] = data.contract_factories.map(
    (factory, index) => ({
      displayOrder: index + 1, // 1-based index
      factoryName: factory.factory, // factory -> factoryName
      deliveryCategory: factory.delivery_classification, // delivery_classification -> deliveryCategory
      quantity: factory.quantity || null,
    })
  );

  // Get common fields from utility
  const commonFields = mapCommonFields(data, canManagePrice);

  // Return combined object
  return {
    ...commonFields,
    fieldStaffs,
    contractFactories,
  };
};
